/**
 * Personstamm API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FieldMetaData } from './fieldMetaData';
import { PsTeilDatumSearchRequestMeta } from './psTeilDatumSearchRequestMeta';
import { PsStrasseFlurnameSearchRequestMeta } from './psStrasseFlurnameSearchRequestMeta';


export interface PersonStammSearchRequestMeta { 
    name?: string;
    mName?: FieldMetaData;
    plz?: number;
    mPlz?: FieldMetaData;
    searchMode?: PersonStammSearchRequestMeta.SearchModeEnum;
    mSearchMode?: FieldMetaData;
    ort?: string;
    mOrt?: FieldMetaData;
    strasseFlurname?: PsStrasseFlurnameSearchRequestMeta;
    mStrasseFlurname?: FieldMetaData;
    vorname?: string;
    mVorname?: FieldMetaData;
    sucheMitGrundbuchbezug?: boolean;
    mSucheMitGrundbuchbezug?: FieldMetaData;
    zpvNummer?: string;
    mZpvNummer?: FieldMetaData;
    geburtsdatum?: PsTeilDatumSearchRequestMeta;
    mGeburtsdatum?: FieldMetaData;
    ahvVersichertennummer?: string;
    mAhvVersichertennummer?: FieldMetaData;
    ahvNummer?: string;
    mAhvNummer?: FieldMetaData;
    sucheOhneGrundbuchbezug?: boolean;
    mSucheOhneGrundbuchbezug?: FieldMetaData;
    uid?: string;
    mUid?: FieldMetaData;
}
export namespace PersonStammSearchRequestMeta {
    export type SearchModeEnum = 'ZPV_SUCHE';
    export const SearchModeEnum = {
        ZPV_SUCHE: 'ZPV_SUCHE' as SearchModeEnum
    };
}


